import * as Schema from "effect/Schema";

/**
 * InlineGridContent — an Inline: a one-row nested grid inside a section. Its
 * children live in the nested grid `nestedGridId` names (like a section's), and
 * are ordinary blocks; `justify` places the packed group in the row.
 */
export const InlineGridContent = Schema.Struct({
  contentType: Schema.Literal("inline-grid"),
  nestedGridId: Schema.String.pipe(Schema.minLength(1)),
  justify: Schema.Literal("start", "center", "end"),
});
export type InlineGridContent = Schema.Schema.Type<typeof InlineGridContent>;
